import { apiClient } from './apiClient';

export const externalApiService = {
  /**
   * List all external APIs for a chatbot (auth values masked).
   */
  async getApis(chatbotId) {
    return apiClient.get(`/api/chatbots/${chatbotId}/external-apis`);
  },

  /**
   * Create a new external API config.
   * @param {number} chatbotId
   * @param {{ name, description, endpointUrl, authHeaderName, authHeaderValue }} data
   */
  async createApi(chatbotId, data) {
    return apiClient.post(`/api/chatbots/${chatbotId}/external-apis`, data);
  },

  /**
   * Update an existing external API config.
   * Pass authHeaderValue as "••••••••" to keep the existing encrypted value.
   */
  async updateApi(chatbotId, id, data) {
    return apiClient.put(`/api/chatbots/${chatbotId}/external-apis/${id}`, data);
  },

  /**
   * Delete an external API config.
   */
  async deleteApi(chatbotId, id) {
    return apiClient.delete(`/api/chatbots/${chatbotId}/external-apis/${id}`);
  },

  /**
   * Toggle the isEnabled flag on an external API.
   */
  async toggleApi(chatbotId, id) {
    return apiClient.put(`/api/chatbots/${chatbotId}/external-apis/${id}/toggle`);
  },

  /**
   * Test whether the external API endpoint is reachable.
   * Returns { reachable, statusCode, preview } or { reachable: false, error }.
   */
  async testApi(chatbotId, id) {
    return apiClient.post(`/api/chatbots/${chatbotId}/external-apis/${id}/test`);
  },
};
